import onEnvironmentChange from '@/observables/environment.observable'
import FingerprintJS from '@fingerprintjs/fingerprintjs'
import type Environment from '@interfaces/environment.interface'
import LogService from '@services/log/log.service'
import MainService from '@services/main/main.service'
import type { AxiosResponse } from 'axios'
import { take } from 'rxjs/operators'

export default class HelaService extends MainService {
  url: string
  GEOIP_URL: string
  logService = new LogService()

  constructor(helaUrl?: string) {
    super()
    if (!helaUrl) {
      onEnvironmentChange.pipe(take(1)).subscribe((environment: Environment) => {
        this.url = environment?.squidApis?.hela
        this.GEOIP_URL = environment?.exteralApis?.geoip
      })
    } else {
      this.url = helaUrl
    }
    this.logService.init('Hela Service')
  }

  async getIp() {
    try {
      const { data } = (await this.http.get(this.GEOIP_URL, { headers: { Accept: 'application/json' } })) || {}
      return data?.ip
    } catch (error) {
      this.logService.error({ message: 'Error on get IP', error })
      return false
    }
  }

  public async patchRecruitmentContract(
    campaignId: string,
    profileIds: string[],
    statusTo: 'recruited' | 'influencerRefused',
    hasContract = true,
    motivation = ''
  ) {
    if (!campaignId) {
      throw new Error('campaignId is required')
    }
    if (!statusTo) {
      throw new Error('statusTo is required')
    }
    if (!profileIds) {
      throw new Error('profileIds is required')
    }
    const payload = {
      campaignId,
      profileIds,
      hasContract,
      motivation,
    }
    const headers = await this.getHeaders()
    const fp = await FingerprintJS.load()
    const { visitorId } = await fp.get()
    const ip = await this.getIp()
    headers['X-Fingerprint'] = `${navigator.userAgent}-${visitorId}`
    headers['X-IP'] = ip
    // Pega o timezone do browser
    headers['timezone'] = Intl.DateTimeFormat().resolvedOptions().timeZone

    return this.http
      .patch(`${this.url}/recruitment/statusTo/${statusTo}/hub`, payload, { headers })
      .then((r: AxiosResponse) => r.data)
      .catch((error: any) => {
        this.logService.error({
          message: `Error on update status ${statusTo} recruitment campaign in ${campaignId}`,
          error,
        })
        throw error.response
      })
  }
}
